import { AccountCreationUiModuleBody, AccountCreationUiModuleBodyModuleTypeEnum, EntitlementType } from '../../../API';
import generateId from '../../../utils/generateId';
import { NewModuleFunction } from '../../../utils/layouts';

export const blankAccountCreationModule: NewModuleFunction<AccountCreationUiModuleBody> = (module) => ({
  moduleType: AccountCreationUiModuleBodyModuleTypeEnum.ACCOUNT_CREATION,
  moduleId: generateId(),
  entitlements: [EntitlementType.ANON, EntitlementType.FREE, EntitlementType.SUB],
  vixLogo: '',
  header: '',
  subheader: '',
  signInCta: '',
  signUpCta: '',
  emailText: '',
  passwordText: '',
  vixDisclaimer: '',
  ...module
});
